'use client'

import {
	CONTEXTUAL_MESSAGE_TYPE,
	ContextualMessage,
} from 'fukku/ContextualMessage/ContextualMessage'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useMapState } from 'maps/hooks/useMapState/useMapState'
import { ERROR_MESSAGE_KEYS } from 'maps/utils/constants'
import {
	isDroppointType,
	isGarmentStoresType,
} from 'maps/utils/mapTypes/mapTypes'

import styles from './StoreListError.module.scss'

export function StoreListError() {
	const { t } = useLabels()
	const { type, stores, loading, hasSearched, filteredStores, onModal } =
		useMapState()

	const hasInitialStores = !!stores?.length || isDroppointType(type)
	const hasResults = hasSearched ? !!filteredStores?.length : hasInitialStores

	if (hasResults || loading) {
		return null
	}

	const showErrorAsContextual = isGarmentStoresType(type) && !stores?.length

	let errorLabel = onModal
		? ERROR_MESSAGE_KEYS.NO_STORES_FOR_LOCATION
		: ERROR_MESSAGE_KEYS.NO_STORES_NEARBY
	if (isDroppointType(type)) {
		errorLabel = ERROR_MESSAGE_KEYS.NO_DROPPOINTS_FOR_LOCATION
	}

	return showErrorAsContextual ? (
		<ContextualMessage
			message={t(ERROR_MESSAGE_KEYS.NO_STORES_FOR_PRODUCT)}
			type={CONTEXTUAL_MESSAGE_TYPE.INFO}
			showIcon
		/>
	) : (
		// biome-ignore lint/a11y/useSemanticElements: fix this
		<p className={styles.text} role='status'>
			{t(errorLabel)}
		</p>
	)
}
